<template>

</template>

<script>
import {defineComponent} from 'vue'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import {isLocal} from '@/helpers.js';

export default defineComponent({
  name: 'WebsocketManager',
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
  },
  created() {

    this.pusher = Pusher;

    this.pusher.logToConsole = isLocal() && false;

    this.echo = new Echo({
      broadcaster: 'reverb',
      key: import.meta.env.VITE_REVERB_APP_KEY,
      wsHost: import.meta.env.VITE_REVERB_HOST,
      wsPort: import.meta.env.VITE_REVERB_PORT,
      wssPort: import.meta.env.VITE_REVERB_PORT,
      forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
      authEndpoint: `${window.app.env.apiBaseUrl}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${window.app.auth.getToken()}`,
        },
      },
    });

    this.channels.import = this.echo.private(`user.${this.user.uuid}`)
      .listen('ImportStatusUpdate', (e) => {
        window.app.emit('importStatusUpdate', e);
      });

  },
  destroyed() {
    if (this.channels.import) {
        this.echo.leaveChannel(`user.${this.user.uuid}`);
    }
  },
  data() {
    return {
      channels: {
        import: null,
      },
      echo: null,
      pusher: null,
    };
  },
});
</script>

<style scoped lang="scss">

</style>
